export const NINETY_PERCENTAGE = 0.9;
export const LIVE_REGION_UPDATE_TIMEOUT = 1000;
export const LIVE_REGION_CLEAR_TIMEOUT = 250;
export const MOBILE_BREAKPOINT = 600;
export const BALLOON_POSITION = {
  TOP: "top left",
  BOTTOM: "bottom left"
};